import { ErrorHandler, Injector } from '@angular/core';
import { isChunkLoadError } from './app-build-fingerprint';
import { AppUpdateService } from './app-update.service';

/**
 * Laat de bestaande ErrorHandler (Sentry) ongemoeid en vraagt daarnaast een update-check
 * wanneer een lazy chunk niet laadt: na een release bestaan de oude chunks niet meer, en
 * zonder herstart blijft dat onderdeel (een `@defer`-blok, een dynamische import) stuk.
 *
 * AppUpdateService wordt pas bij de eerste chunk-fout opgehaald: de ErrorHandler wordt heel
 * vroeg aangemaakt, en meteen Router/MatDialog meetrekken geeft een cyclische afhankelijkheid.
 */
export class AppUpdateAwareErrorHandler implements ErrorHandler {
  constructor(
    private readonly inner: ErrorHandler,
    private readonly injector: Injector
  ) {}

  handleError(error: unknown): void {
    this.inner.handleError(error);

    if (isChunkLoadError(error)) {
      void this.injector.get(AppUpdateService).checkNow('chunk');
    }
  }
}
